import React from 'react';
import { Label as ShadcnLabel } from '@/components/ui/shadcn/label';
import { cn } from '@/lib/utils';

export interface LabelProps extends React.ComponentProps<typeof ShadcnLabel> {}

function Label({ className, ref, ...props }: LabelProps) {
  return (
    <ShadcnLabel
      ref={ref}
      className={cn(className)}
      {...props}
    />
  );
}

export { Label };
